import {CallJs} from "../lib/types";
import * as React from "react"
import * as ReactDOM from "react-dom"
import {DatePicker} from "../lib/sbhtml/datePicker";
import {FormButtons} from "../legacy/form-buttons";

type CommonFormParams = {
	action: string
	page: string
	form_processing_message: string
	version_label: string
	file_label: string
	result: {
		title: string
		version_number: string
		serial: string
		expiry_date: string|null
		version_comment: string
	}
}

type VersionFormParams = CommonFormParams & ({
	type: "update"
	params: {
		window_num: number
		parent_id: number|null
		id: string
	}
	result : {
		previously_published_status: number
		version_serial: string
		version_original_filename: string
		version_read_filename: string
	}
} | {
	type: "new"
	params: {
		window_num: number
		parent_id: number
		is_publishable: boolean
	}
})

declare function validate(form: HTMLFormElement): boolean

export const run_version_form: CallJs<VersionFormParams> = (replace, params) => {

	const div = document.createElement('div')

	replace(div)

	ReactDOM.render(<Form {...params} />, div)
}

type FormState = {
	publish_status: 0|1|3|null
}

type FormProps = VersionFormParams

const ensure_valid_published_status = (status: number): 0|1|3|null => {
	switch (status) {
		case 0: return 0
		case 1: return 1
		case 3: return 3
		default: return null
	}
}

class Form extends React.Component<FormProps, FormState> {
	updatePublishStatus: (status: 0|1|3) => void

	constructor(p: FormProps, ctx: any) {
		super(p, ctx);
		this.state = {publish_status: ensure_valid_published_status(p.type == 'new' ? 0 : p.result.previously_published_status)}
		this.updatePublishStatus = (status) => this.setState({publish_status: status})
	}

	render() {
		const params = this.props

		const onsubmit = function (e: React.FormEvent<HTMLFormElement>) {
			const form = document.getElementById('my_form')
			if (form && form instanceof HTMLFormElement && validate(form)) {
				const buttons = document.getElementById('my_form_buttons')
				if(buttons)
					buttons.innerHTML = params.form_processing_message
				return true
			} else {
				e.preventDefault()
				return false
			}
		}

		const mode: FormPublishMode = params.type == 'new' ? {type: 'new'} : {
			type: 'update',
			id: params.params.id,
			read_only_file_link: '',
			read_only_filename: params.result.version_read_filename,
		}

		const publish_params: FormPublishParams = {
			name: 'PublishedStatus',
			label: params.type == 'new' && !params.params.is_publishable ? 'Publish Request' : 'Publish',
			title: '',
			allow_read_only_upload: true,
			file_id: params.result.serial,
			mode
		}

		const publish_props: FormPublishProps = {
			params: publish_params,
			file_label: params.file_label,
			page: params.page,
			published_status: this.state.publish_status,
			update: this.updatePublishStatus
		}

		const expiry_date = params.result.expiry_date ? new Date(params.result.expiry_date) : null

		return <form id="my_form" name="my_form" action={params.action} method='post' encType='multipart/form-data'
			onSubmit={onsubmit}
		>
			{ params.type == "update" &&
			<input type="hidden" name="id" value={params.params.id} />
			}
			<input type="hidden" name="window_num" value={params.params.window_num.toString()} />
			<input type="hidden" name="DataSerial" value={params.params.parent_id == null ? '' : params.params.parent_id.toString()} />
			<input type="hidden" name="VersionNumber" value={""} />
			<input type="hidden" name="previous_published_status" value={"" + (params.type == 'new' ? 0 : params.result.previously_published_status)} />
			<input type="hidden" name="ParentSerial" value="" />{/*todo remove me?*/}

			<div className="border">
				<div className="fieldset_title">{params.version_label.toUpperCase()} FORM</div>
				<div style={{overflow: 'auto'}}>
					<div className="form">
						<table style={{border: 0}}>
							<FormReadOnly name="file_label" label={params.file_label} value={params.result.title}/>
							<FormReadOnly name="version_label" label={params.version_label} value={params.result.version_number}/>
							{params.type == 'new'
								? <FormInput class_name='medium' title='Upload' label='Upload' name='upload' type='file' />
								: <RowStart name="link">
									<a href={`${params.page}?command=download_version&id=${params.result.version_serial}`} target="_new">{params.result.version_original_filename}</a>
								</RowStart>
							}
							<ControlledFormPublish {...publish_props} />
							<FormInputDate visible={!!this.state.publish_status} value={expiry_date} name="ExpiryDate"  label="Expiry Date" title="moo" date_format="d/m/Y" />
							<FormTextArea title="" name="VersionComment" value={params.result.version_comment} label="Comment" className="small" width="250px" />
						</table>
					</div>
				</div>
			</div>
			<br />
			<FormButtons
				form="my_form"
				single={true}
				command_value=""
				cancel={() => {self.close()}}
				cancel_label="Close"
				enableCancel={true}
				save_label="Save"
			/>
		</form>
	}
}

type FormInputProps = {
	type: 'file'
	name: string
	label: string
	title: string
	class_name: 'small'|'medium'|'large'
}

type FormInputState = {
	blurred: boolean
}

class FormInput extends React.Component<FormInputProps, FormInputState> {
	onblur: () => void
	onfocus: () => void

	constructor(p: FormInputProps, ctx: any) {
		super(p, ctx);
		this.state = {blurred: true}
		this.onblur = () => this.setState({blurred: true})
		this.onfocus = () => this.setState({blurred: false})
	}
	render() {
		const params = this.props
		const class_name = `input_${params.class_name}_${this.state.blurred ? 'off' : 'on'}`

		return <RowStart {...params}>
			<input type={params.type}
				name={params.name}
				title={params.title}
				className={class_name}
				/>
		</RowStart>
	}
}

type FormInputDateParams = {
	label: string
	value: Date|null
	name: string
	title: string
	//style: React.CSSProperties
	date_format: string
	visible: boolean
}

type FormCommentParams = {
	label: string
	className: 'large' | 'small' | 'medium'
	value: string
	name: string
	title: string
	width: string
}
type FormCommentState = {
	value: string
	blurred: boolean
}

class FormTextArea extends React.Component <FormCommentParams, FormCommentState> {
	onblur: () => void
	onfocus: () => void

	constructor(p: FormCommentParams, ctx: any) {
		super(p, ctx);
		this.state = {value: p.value, blurred: true}
		this.onblur = () => this.setState({blurred: true})
		this.onfocus = () => this.setState({blurred: false})
	}

	render() {
		const params = this.props
		const className = `textarea_${params.className}_${this.state.blurred ? "off" : "on"}`
		return <RowStart {...params}>
			<textarea id={params.name} name={params.name} title={params.title}
				style={{width: params.width}} className={className}
				onBlur={this.onblur}
				onFocus={this.onfocus}
				defaultValue={this.state.value}
			/>
		</RowStart>
	}
}

type FormInputDateState = {
	value: Date|undefined
}

class FormInputDate extends React.Component<FormInputDateParams, FormInputDateState> {
	clear: () => void
	onChange: (text: string, e: Date) => void

	constructor(props?: FormInputDateParams, context?: any) {
		super(props, context)
		this.state = {
			value : this.props.value || undefined
		}
		this.clear = () => this.setState({value: undefined})
		this.onChange = (s, d) => this.setState({value: d})
	}

	pad(str: string, zero: string, len: number): string {
		return str.length < len && zero.length >= 1 ? this.pad(zero + str, str, len) : str
	}

	formatDMY(): string {
		if(!this.state.value) return '';

		const month = this.pad((this.state.value.getMonth() + 1).toString(), '0', 2)
		const date = this.pad((this.state.value.getDate()).toString(), '0', 2)

		return `${this.state.value.getFullYear()}-${month}-${date}`
	}

	render() {
		const params = this.props

		const date_str = this.formatDMY()

		return <RowStart {...params}>
			<div style={{visibility: params.visible ? 'visible' : 'hidden'}} id={`${params.name}_div`}>
				<table style={{border: 0, width: "100%"}} cellPadding={0} cellSpacing={0}>
					<tbody>
					<tr>
						<td>
							<input name="ExpiryDate" type="hidden" value={date_str}  />
							<DatePicker date={this.state.value} onChange={this.onChange} readonly={false} invalid={false} hasClearButton={this.clear} />
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</RowStart>
	}
}

type FormPublishMode = {
	type: 'update'
	id: string
	read_only_file_link: string
	read_only_filename: string
} | {type: 'new'}

type FormPublishParams = {
	allow_read_only_upload: boolean
	name: string
	file_id: string
	label: string
	title: string
	mode: FormPublishMode
}

type FormPublishProps = {
   params: FormPublishParams
	file_label: string
	page: string
	published_status: 0|1|3|null,
	update: (key: 0|1|3) => void
}

/*
class SelfControlledFormPublish extends React.Component<FormPublishProps, FormPublishState> {
	update: (key: 0|1|3) => void

	constructor(props: FormPublishProps, context?: any) {
		super(props, context)
		this.state = {published_status}
		this.update  = (key: 0|1|3)  => this.setState({published_status: key})
	}

	render() {
		return <ControlledFormPublish update={this.update} {...this.props} published_status={this.state.published_status} />
	}
}*/

class ControlledFormPublish extends React.Component<FormPublishProps, {focused: boolean}> {
	blur: () => void
	focus: () => void


	constructor(props: FormPublishProps, context?: any) {
		super(props, context)
		this.state = {focused: false}
		this.blur = () => this.setState({focused: false})
		this.focus = () => this.setState({focused: true})
	}

	render() {
		const params = this.props
		const values: [0|1|3, string][] =
			[[0, "Not published"], [1, "In original format"]]

		if (params.params.allow_read_only_upload)
			values.push([3, `Uploaded read only file ${params.params.mode.type == 'update' ? params.params.mode.read_only_filename : ''}`])

		const read_upload_title = params.params.mode.type == 'update' ?  '' : "Upload read only " + params.file_label.toLowerCase()

		const logically_selected =
			params.published_status == null && params.params.mode.type == 'update' && params.params.mode.read_only_file_link
				? 3
				: (params.published_status || 1)

		const is_visible = logically_selected == 3
		const visibility = is_visible
			? "visible"
			: "hidden"

		return <RowStart {...params.params}>
			<table cellPadding="0" cellSpacing="0" style={{border: "0", width: "100%"}}>
				<tbody>
				{values.map(([key, text]) => <tr key={key} style={{cursor: "pointer"}}>
					<td style={{width: 10}}>
						<div style={{textAlign: "right"}}>
							<input onChange={() => this.props.update(key)} type="radio" id={`radio_${key}_{params.params.name}`} name={params.params.name} value={key} checked={key == logically_selected} />
						</div>
					</td>
					<td><label htmlFor={`radio_${key}_{params.params.name}`}>{text}</label>{"\xa0"}</td>
				</tr>)}
				</tbody>
			</table>
			<div id="read_upload_div" style={{visibility}}>
				{params.params.mode.type == 'update' && params.params.mode.read_only_file_link
					?
					<span style={{padding: "20px"}}><a href={`${params.page}?command=download_read_only_file&id=${params.params.mode.id}`} target="_new">{params.params.mode.read_only_file_link}</a></span>
					:
					<input data-sb-known-valid={is_visible ? null : true} onBlur={this.blur} onFocus={this.focus} id="read_upload" type="file" name="read_upload" title={read_upload_title} className={(is_visible ? "" : "sb-known-valid") + " " + (this.state.focused? "input_medium_on" : "input_medium_off")} />
				}
			</div>
		</RowStart>
	}
}

type RowParams = {
	children: React.ReactElement<any>|string|React.ReactElement<any>[]
	title?: string,
	name: string,
	label?: string,
	label_color?: string,
	align?: string,
	full_span?: boolean,
	label_visibility?: 'visible'|'hidden'
	//todo: display param?
	help_content?: string //todo deprecate/convert to text
}

 const RowStart = (params: RowParams) => {
		const label_visibility = params.label_visibility || 'visible'

		const span = params.full_span ? 2 : undefined

		const content =
			<td style={{textAlign:params.align}} id={`${params.name}_td`} colSpan={span}>
				{params.children}
			</td>

		const header =
			<th id={`${params.name}_th`} style={{textAlign:"left"}} colSpan={span}>
				<div id={`${params.name}_label`} style={{visibility: label_visibility }}>
					<table cellPadding="0" cellSpacing="0" style={{width:"100%", border: 0}}>
						<tbody>
						<tr>
							<th>
								{params.help_content /*todo ensure this is valid text, it's likely html :/*/}
							</th>
							<th style={{color: params.label_color}}>
								{params.label}
							</th>
						</tr>
						</tbody>
					</table>
				</div>
			</th>

		if(params.full_span) {
			return <tbody> <tr id={`${params.name}_row`}>
				{header}
			</tr>
			<tr>
				{content}
			</tr></tbody>

		} else {
			return <tbody><tr id={`${params.name}_row`}>
				{header}
				{content}
			</tr></tbody>
		}
}

const FormReadOnly = ({name, label, value}: {name: string, label: string, value: string}) => {
	return <RowStart name={name} label={label}>{value}</RowStart>
}




// WEBPACK FOOTER //
// ./src/memory/version-form.tsx